// extracted by mini-css-extract-plugin
module.exports = {"container":"Course_container__3GRvx","content":"Course_content__3-9F1","course_does_not_exist":"Course_course_does_not_exist__1AG84","panel":"Course_panel__2sbBP"};